export default __webpack_public_path__ + "static/media/requestQuoteLight.398a82de.svg";